/**
 * A tiny external store tracking which mindmap node ids have an expand fetch in
 * flight (Fix 2). The expand orchestrator marks/clears ids around its async
 * fetch; RenderMindmapNode subscribes and shows an in-place busy state on the
 * clicked chip — feedback at the point of interaction, replacing the easily
 * missed bottom "Expanding…" toast. Kept in its own module so the DOM renderer
 * can subscribe without importing the whole expand pipeline (Notion services).
 */

const inFlight = new Set<string>();
const listeners = new Set<() => void>();

const notify = (): void => {
  for (const listener of listeners) {
    listener();
  }
};

/** Mark an element's expand fetch as in flight and notify subscribers. */
export const markExpandInFlight = (elementId: string): void => {
  inFlight.add(elementId);
  notify();
};

/** Clear an element's in-flight mark and notify subscribers. */
export const clearExpandInFlight = (elementId: string): void => {
  inFlight.delete(elementId);
  notify();
};

/** Whether an element's expand fetch is currently in flight. */
export const isExpandInFlight = (elementId: string): boolean =>
  inFlight.has(elementId);

/**
 * Subscribe to in-flight changes (for `useSyncExternalStore`). Returns an
 * unsubscribe function.
 */
export const subscribeExpandInFlight = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
